// extracted by mini-css-extract-plugin
module.exports = {"label":"Checkbox_label__U76aJ","inputWrapper":"Checkbox_inputWrapper__TGWgd","checkmark":"Checkbox_checkmark__NCbUN","textError":"Checkbox_textError__U1JrR"};